<template>
  <div>
    <h1 class="text-center mt-3">Mobile App Supported Versions</h1>
    <v-progress-circular
      v-if="isLoading"
      :size="70"
      :width="7"
      color="primary"
      indeterminate
      class="centered"
    ></v-progress-circular>
    <div v-else>
      <div class="form shadow p-5 mb-5 bg-white rounded">
        <h4 class="mb-0">iOS</h4>
        <div class="row mb-5">
          <div class="col-6">
            <label for="iosMinimum">Minimum build number</label>
            <input
              id="iosMinimum"
              type="text"
              v-model="form.iosMinimum"
              class="form-control"
              :class="{
                'input--error': isSubmit && error.errorIosMinimum,
              }"
            />
            <div v-if="isSubmit && error.errorIosMinimum" class="text-error">
              {{ error.errorIosMinimum.message }}
            </div>
          </div>
          <div class="col-6">
            <label for="iosCurrent">Current build number</label>
            <input
              id="iosCurrent"
              type="text"
              v-model="form.iosCurrent"
              class="form-control"
              :class="{
                'input--error': isSubmit && error.errorIosCurrent,
              }"
            />
            <div v-if="isSubmit && error.errorIosCurrent" class="text-error">
              {{ error.errorIosCurrent.message }}
            </div>
          </div>
        </div>
        <h4 class="mb-0">Android</h4>
        <div class="row mb-5">
          <div class="col-6">
            <label for="androidMinimum">Minimum build number</label>
            <input
              id="androidMinimum"
              type="text"
              v-model="form.androidMinimum"
              class="form-control"
              :class="{
                'input--error': isSubmit && error.errorAndroidMinimum,
              }"
            />
            <div
              v-if="isSubmit && error.errorAndroidMinimum"
              class="text-error"
            >
              {{ error.errorAndroidMinimum.message }}
            </div>
          </div>

          <div class="col-6">
            <label for="androidCurrent">Current build number</label>
            <input
              id="androidCurrent"
              type="text"
              v-model="form.androidCurrent"
              class="form-control"
              :class="{
                'input--error': isSubmit && error.errorAndroidCurrent,
              }"
            />
            <div
              v-if="isSubmit && error.errorAndroidCurrent"
              class="text-error"
            >
              {{ error.errorAndroidCurrent.message }}
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-end mt-5">
          <button
            class="btn btn-outline-danger ml-10"
            @click="() => $router.go()"
          >
            Cancel
          </button>
          <button class="btn btn-outline-success ml-10" @click="onSubmit">
            Save
          </button>
        </div>

        <v-dialog v-model="showDialog" width="500" persistent>
          <div class="content-dialog">
            <h3 class="p-5">{{ message }}</h3>
            <div class="text-center">
              <button class="btn-back" @click="showDialog = false">ปิด</button>
            </div>
          </div>
        </v-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import MobileAppSupportedVersionService from "services/api/mobileAppSupportedVersion.service";

export default {
  data() {
    return {
      message: "",
      showDialog: false,
      isLoading: true,
      isSubmit: false,
      form: {
        iosMinimum: null,
        iosCurrent: null,
        androidMinimum: null,
        androidCurrent: null,
      },
      error: {
        errorIosMinimum: null,
        errorIosCurrent: null,
        errorAndroidMinimum: null,
        errorAndroidCurrent: null,
      },
    };
  },
  mounted() {
    this.getMobileAppSupportedVersion();
  },
  methods: {
    onSubmit() {
      this.isSubmit = true;
      this.isLoading = true;
      this.resetErrorText();
      const form = this.form;
      const body = {
        iosMinimum: form.iosMinimum,
        iosCurrent: form.iosCurrent,
        androidMinimum: form.androidMinimum,
        androidCurrent: form.androidCurrent,
      };

      this.updateMobileAppSupportedVersion(body);
    },
    async updateMobileAppSupportedVersion(body) {
      await MobileAppSupportedVersionService.setMobileAppSupportedVersion(body)
        .then(async (res) => {
          const data = res.data;
          await this.getMobileAppSupportedVersion();
          this.isLoading = false;
          this.showDialog = true;
          this.message = data.message
            ? data.message
            : "Save mobile app supported versions success";
        })
        .catch((err) => {
          this.isLoading = false;
          const errorData = err.response?.data;
          if (errorData?.message) {
            this.showDialog = true;
            this.message = errorData.message;
          }
          if (errorData.errors?.length > 0) {
            this.setErrorText(errorData.errors);
          }
        });
    },
    async getMobileAppSupportedVersion() {
      await MobileAppSupportedVersionService.getMobileAppSupportedVersion()
        .then((res) => {
          const data = res.data?.data;
          this.isLoading = false;
          const form = this.form;
          form.iosMinimum = data.iosMinimum;
          form.iosCurrent = data.iosCurrent;
          form.androidMinimum = data.androidMinimum;
          form.androidCurrent = data.androidCurrent;
        })
        .catch((err) => {
          this.isLoading = false;
          const errorData = err.response?.data;
          if (errorData?.message) {
            this.showDialog = true;
            this.message = errorData.message;
          }
        });
    },
    setErrorText(errors) {
      this.error.errorIosMinimum = errors.find(
        (e) => e.fieldName === "iosMinimum"
      );
      this.error.errorIosCurrent = errors.find(
        (e) => e.fieldName === "iosCurrent"
      );
      this.error.errorAndroidMinimum = errors.find(
        (e) => e.fieldName === "androidMinimum"
      );
      this.error.errorAndroidCurrent = errors.find(
        (e) => e.fieldName === "androidCurrent"
      );
    },
    resetErrorText() {
      this.error.errorIosMinimum = null;
      this.error.errorIosCurrent = null;
      this.error.errorAndroidMinimum = null;
      this.error.errorAndroidCurrent = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.text-error {
  color: red;
  font-size: 12px;
}

.content-dialog {
  height: 300px;
  background: #fff;
  overflow-x: hidden;

  h3 {
    text-align: center;
    padding: 5rem 0 2rem;
  }

  .btn-back {
    border: 1px solid #1976d2;
    width: 28%;
    height: 39px;
    border-radius: 25px;
    color: #1976d2;
  }

  .btn-back:hover {
    text-decoration: underline;
  }
}
</style>
